import React, { useEffect, useState } from "react";
import { Modal, Box, Button } from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import authAxios from "setups/axios";

let schemeConstants = {
  apollo: 1,
  APOLLO: 1,
  apolo: 1,
  APOLO: 1,
  Apolo: 1,
  CEAT: 2,
  ceat: 2,
  Ceat: 2,
  mrf: 3,
  MRF: 3,
  Mrf: 3,
  bridgestone: 4,
  Bridgestone: 4,
  BridgeStone: 4,
  BRIDGESTONE: 4,
  "bridge stone": 4,
  "bridge-stone": 4,
  "Bridge Stone": 4,
  "Bridge-Stone": 4,
  "Bridge stone": 4,
  "Bridge-stone": 4,
  "BRIDGE STONE": 4,
  YOKOHAMA: 5,
  yokohama: 5,
  Yokohama: 5,
  Yokoohama: 5,
};

let jsonObj = {
  Company_Name: "APOLLO TYRES LTD",
  Policy_Title: "PCR Commercial Policy 2023-2024",
  Document_Tagline: "WE ARE APOLLO",
  Sales_Productivity_Discount_Name: "SALES PRODUCTIVITY DISCOUNT (SPD)",
  Spd_Table: {
    Name: "SPD Table",
    Headers: ["Rotation", "SPD% (All categories)"],
    Rows: [
      ["<1.5 Times", "0%"],
      ["1.5-2.24 Times", "1.40%"],
    ],
  },
  Additional_Spd_Note:
    "In case of Exclusive Dealers, they would be eligible for additional SPD of 0.25% over & above the rate specified above.",
  Spd_Discount_Policy:
    "SPD Discount will not be paid on claim billing. SPD Discount would be given at 1.75% on Body of invoice & balance through credit note on quarterly basis.",
  Website: "apollotyres.com",
  Tbd_Table: {
    Name: "Monthly Slabs for Target Based Discount (TBD)",
    Headers: ["Monthly Slabs", "Discount (% on M.V.)"],
    Rows: [
      ["0 to 39 Tyres", "0.00%"],
      ["40-79 PCR Tyres", "2.25%"],
    ],
  },
  Orientation_Period_Policy:
    "New dealers would be eligible for minimum of 2.25% TBD for Two Quarters.",
  Branded_Retail_Incentive_Table: {
    Name: "Branded Retail Incentive",
    Headers: ["Status", "Branded Retail Incentive"],
    Rows: [
      ["Apollo Super Zone", "3.00%"],
      ["Apollo Zone", "2.50%"],
    ],
  },
  Branded_Retail_Incentive_Conditions: "The above incentive will be given.",
};

// let jsonObj1 = {
//   "Reference Number":
//     'C/DIS/23-24/Q3/252","Date":"29th Sep 2023","To":"ZONAL MANAGERS / REGIONAL MANAGERS","Subject":"Tyre Exchange Offer","Applicable":"All Zones, Dealer Channel only","Product Category":"PCR/UVR (2090,2100)","Validity For Dealers":"29th Sep to 28 Nov 2023","Validity For Customers":"5th Oct to 30th Nov 2023","Exclusion":"Claim/Sludge/Test/FOC/NOE","Scheme Details":"Product BOI discount as per the below grid for the Dealer in Table 1, Dealer Needs to pass on the discount to the customer as per Table 2","Dealer Offer ":{"Name":"Dealer Offer ","Headers":{"RIM Size":"RIM Size","Milaze+":"Milaze+","SecuraDrive":"SecuraDrive","SportDrive":"SportDrive","CrossDrive":"CrossDrive"},"Rows":[{"RIM Size":"12\\"-14\\"","Milaze+":"225","SecuraDrive":"-","SportDrive":"-","CrossDrive":"-"},{"RIM Size":"15\\"-16\\"","Milaze+":"275","SecuraDrive":"500","SportDrive":"-","CrossDrive":"750"},{"RIM Size":"17\\"+","Milaze+":"300","SecuraDrive":"1200","SportDrive":"1200","CrossDrive":"1200"},{"RIM Size":"","Milaze+":"","SecuraDrive":"","SportDrive":"","CrossDrive":""}]},"Customer Offer (on 2 or 4 Tyres only)":{"Name":"Customer Offer (on 2 or 4 Tyres only)","Headers":["RIM Size","Milaze","Secura Drive","SportDrive","Cross Drive"],"Rows":[{"RIM Size":"12\\"-14\\"","Milaze":"150","Secura Drive":"-","SportDrive":"-","Cross Drive":"-"},{"RIM Size":"15\\"-16\\"","Milaze":"200","Secura Drive":"400","SportDrive":"-","Cross Drive":"600"},{"RIM Size":"17\\"+","Milaze":"-","Secura Drive":"1000","SportDrive":"1000","Cross Drive":"1000"}]},"Milaze Includes":"Milaze | Milaze X3 | CZAR | BT STEEL | STEEL PLUS | EnergyDrive","Mode Of Disbursal":"Body of invoice (BOI) to the Dealer, Discount on invoice to the customers as per Grid in Table 2 by the dealers","Terms And Conditions":"Discount will be given to the Dealer on invoice as per Table 1, Dealer needs to pass on the discount as per Table 2 to the customers on invoice, CEAT hold the rights to change/modify/withdraw the scheme without any prior notice, Offer available only at Authorized CEAT dealers, Customer is not eligible for Tyre Exchange offer on Claim Tyres',
// };

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: "80%",
  overflowY: "auto",
  padding: "1rem",
  bgcolor: "white",
  boxShadow: 24,
  p: 2,
  textAlign: "center",
};

const SchemeView = ({ view, handleViewClose, data, handleReload }) => {
  const [jsonData, setJsonData] = useState();
  const [surveyId, setSurveyId] = useState();

  useEffect(() => {
    setJsonData(data ? JSON.parse(data?.document) : null);
    setSurveyId(data?._id);
  }, [data]);

  console.log("new data", data);

  const handleInputChange = (key, value) => {
    setJsonData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleTableInputChange = (key, rowIndex, columnIndex, value) => {
    setJsonData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        Rows: prevData[key].Rows.map((row, index) =>
          index === rowIndex
            ? row.map((val, idx) => (idx === columnIndex ? value : val))
            : row
        ),
      },
    }));
  };

  console.log("json", jsonData);

  const convertCamelCase = (text) => {
    return text.replace(/_/g, " ");
  };

  const updatedString = (str, schemeConstants) => {
    return Object?.entries(schemeConstants).reduce((acc, [key, value]) => {
      const regex = new RegExp(key, "gi");
      return acc.replace(regex, value);
    }, str);
  };

  const handleSubmit = async () => {
    const response = await authAxios()({
      url: `/api/v1/scan/admin/update?id=${surveyId}`,
      method: "PUT",
      data: { document: JSON.stringify(jsonData) },
    });
    toastMessage(response?.data?.message, "success");
    handleViewClose();
    handleReload();
  };

  return (
    <>
      <Modal open={view} onClose={handleViewClose}>
        <Box sx={messageStyle}>
          <h2 style={{ textDecoration: "underline", marginBottom: "2rem" }}>
            View Survey
          </h2>
          <button
            style={{
              position: "fixed",
              top: "10px",
              right: "10px",
              border: "2px solid darkgrey",
              padding: "15px",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "3px",
              color: "red",
              fontWeight: "600",
              fontSize: "24px",
              cursor: "pointer",
            }}
            onClick={handleViewClose}
          >
            X
          </button>

          {jsonData
            ? Object?.keys(jsonData).map((key) => {
                if (
                  typeof jsonData[key] === "object" &&
                  jsonData[key]?.Headers &&
                  jsonData[key]?.Rows
                ) {
                  return (
                    <div key={key}>
                      <h3 style={{ textAlign: "left", marginBottom: "1rem" }}>
                        {updatedString(jsonData[key]?.Name, schemeConstants)}
                      </h3>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: "1rem",
                        }}
                      >
                        <thead>
                          <tr>
                            {jsonData[key]?.Headers.map((header, index) => (
                              <th
                                key={index}
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {updatedString(header, schemeConstants)}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {jsonData[key]?.Rows?.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {row?.map((value, columnIndex) => (
                                <td
                                  key={columnIndex}
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={updatedString(
                                      value,
                                      schemeConstants
                                    )}
                                    onChange={(e) =>
                                      handleTableInputChange(
                                        key,
                                        rowIndex,
                                        columnIndex,
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      width: "100%",
                                      boxSizing: "border-box",
                                    }}
                                  />
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={key}
                      style={{ display: "flex", marginBottom: "1rem" }}
                    >
                      <label style={{ marginRight: "1rem" }}>
                        {convertCamelCase(key)}
                      </label>
                      <input
                        type="text"
                        value={updatedString(jsonData[key], schemeConstants)}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                        style={{
                          flex: "1",
                          padding: "5px",
                          borderRadius: "3px",
                          border: "1px solid #ccc",
                          width: "100%",
                          display: "block",
                          resize: "none",
                        }}
                      />
                    </div>
                  );
                }
              })
            : null}

          {jsonData ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "0 1rem",
                marginTop: "2rem",
              }}
            >
              <Button
                variant="contained"
                style={{ marginRight: "2rem" }}
                onClick={handleSubmit}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={handleViewClose}
              >
                Cancel
              </Button>
            </div>
          ) : null}
        </Box>
      </Modal>
    </>
  );
};

export default SchemeView;
